import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import { OuterBox, SubheaderSection, LoadingButton } from "./../../components";
import { useAxiosV2, useComponent } from "../../hooks/";
import Aadharverificaion from "./Aadharverificaion/Aadharverificaion";
import DrivingLicence from "./DrivingLicence/DrivingLicence";
import UploadDocument from "../../pages/UploadDocument/UploadDocument";
import { useDispatch } from "react-redux";
import { Loader } from "../../components";

const WelcomeScreen = ({ setAadharVerified }) => {
  const [identityType, setIdentityType] = useState("aadhaar");
  const [verification, setVerification] = useState(false);
  const axiosAadhar = useAxiosV2({ baseURL: "aadharUrl" });
  const [token, setToken] = React.useState("");

  const [verificationFailedCount, setVerificationFailedCount] =
    React.useState(0);
  const handleProceed = () => {
    setVerification(true);
  };
  const dispatch = useDispatch();
  const handleIdentityTypeChange = (event) => {
    setIdentityType(event.target.value);
  };

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const visitorId = queryParams.get("visitor_id");
  if (visitorId !== null) {
    sessionStorage.setItem("visitorId", visitorId);
  }
  const id = queryParams.get("id");
  if (id !== null) {
    sessionStorage.setItem("id", id);
  }
  const bookingType = queryParams.get("booking_type");
  const { loader } = useComponent();

  useEffect(() => {
    loader.start();
    axiosAadhar({
      url: `/login/`,
      method: "POST",
      data: {
        client_secret: "dmVyaXNtYXJ0",
      },
    })
      .then((response) => {
        if (response.success) {
          setToken(response.access_token);
          loader.stop();
        } else {
          dispatch(
            alert({
              type: "error",
              message: "Token generation failed",
            })
          );
          loader.stop();
        }
      })
      .catch((error) => {
        console.error("Error in token generation ", error);
      });
  }, []);

  if (!verification) {
    return (
      // <Loader>
      <OuterBox>
        <SubheaderSection
          textAlign="left"
          title="Document Verification"
          content=" Choose an Identification Document from the Options Below"
        />

        <form>
          <FormControl
            fullWidth
            variant="outlined"
            sx={{ marginBottom: "16px" }}
          >
            <InputLabel id="demo-simple-select-label">
              Select Document
            </InputLabel>
            <Select
              label="Select Booking Type"
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              displayEmpty
              onChange={handleIdentityTypeChange}
              value={identityType}
              name="identityType"
            >
              <MenuItem value="dl">Driving License</MenuItem>
              <MenuItem value="aadhaar">Aadhar Card</MenuItem>
            </Select>
          </FormControl>
          <LoadingButton onClick={handleProceed}>Proceed</LoadingButton>
        </form>
      </OuterBox>
      // </Loader>
    );
  }

  if (verificationFailedCount === 3) {
    return (
      <UploadDocument
        setAadharVerified={setAadharVerified}
        token={token}
        visitorId={visitorId}
        bookingType={bookingType}
        id={id}
        setVerificationFailedCount={setVerificationFailedCount}
        identityType={identityType}
      />
    );
  }

  if (identityType === "aadhaar" && verificationFailedCount !== 3 && token) {
    return (
      <Aadharverificaion
        setAadharVerified={setAadharVerified}
        token={token}
        visitorId={visitorId}
        bookingType={bookingType}
        id={id}
        setVerificationFailedCount={setVerificationFailedCount}
        verificationFailedCount={verificationFailedCount}
        setVerification={setVerification}
      />
    );
  }

  if (identityType === "dl" && verificationFailedCount !== 3 && token) {
    return (
      <DrivingLicence
        token={token}
        visitorId={visitorId}
        bookingType={bookingType}
        id={id}
        setVerificationFailedCount={setVerificationFailedCount}
        verificationFailedCount={verificationFailedCount}
        setVerification={setVerification}
      />
    );
  }
};

export default WelcomeScreen;
